// extracted by mini-css-extract-plugin
module.exports = {"tab-section":"SkyUseCases_tab-section__3ldsA","active-usecase-button":"SkyUseCases_active-usecase-button__1a0lc","disabled-button":"SkyUseCases_disabled-button__34pPH"};